import { cn } from '../../../lib/utils';
import { fmtValue } from '../../broker/bookUtils';

// Manual-Trading-specific badge styling. The shared STATUS_META keys
// (ACTIVE/PAUSED/STOPPED…) don't cover these statuses, so we keep a small local
// map here using the same theme tokens — no shared utils are modified.

const STRATEGY_STATUS = {
  LIVE:    { label: 'LIVE',    cls: 'bg-bull/10 border-bull/30 text-bull',           dot: 'bg-bull', pulse: true },
  PAPER:   { label: 'PAPER',   cls: 'bg-info/10 border-info/30 text-info',           dot: 'bg-info', pulse: true },
  STOPPED: { label: 'STOPPED', cls: 'bg-bg-hover border-bg-border text-txt-muted',   dot: 'bg-txt-muted' },
};

const ROW_STATUS = {
  Ready:   'bg-bg-hover border-bg-border text-txt-secondary',
  Open:    'bg-info/10 border-info/30 text-info',
  Pending: 'bg-warn/10 border-warn/30 text-warn',
  Blocked: 'bg-bear/10 border-bear/30 text-bear',
  // Order lifecycle statuses (Title Case — Fyers-numeric-normalized orders)
  Filled:        'bg-bull/10 border-bull/30 text-bull',
  'Part Filled': 'bg-info/10 border-info/30 text-info',
  Cancelled:     'bg-bg-hover border-bg-border text-txt-muted',
  Rejected:      'bg-bear/10 border-bear/30 text-bear',
  // Order lifecycle statuses (upper-case — PAPER engine / raw string broker statuses)
  SUCCESS:      'bg-bull/10 border-bull/30 text-bull',
  FILLED:       'bg-bull/10 border-bull/30 text-bull',
  COMPLETE:     'bg-bull/10 border-bull/30 text-bull',
  COMPLETED:    'bg-bull/10 border-bull/30 text-bull',
  REJECTED:     'bg-bear/10 border-bear/30 text-bear',
  FAILED:       'bg-bear/10 border-bear/30 text-bear',
  ERROR:        'bg-bear/10 border-bear/30 text-bear',
  CANCELLED:    'bg-bg-hover border-bg-border text-txt-muted',
  CANCELED:     'bg-bg-hover border-bg-border text-txt-muted',
  PENDING:      'bg-info/10 border-info/30 text-info',
  OPEN:         'bg-info/10 border-info/30 text-info',
  SUBMITTED:    'bg-info/10 border-info/30 text-info',
  PART_FILLED:  'bg-info/10 border-info/30 text-info',
};

export function StrategyStatusBadge({ status, className }) {
  const meta = STRATEGY_STATUS[status] || STRATEGY_STATUS.STOPPED;
  return (
    <span className={cn('badge border', meta.cls, className)}>
      <span className={cn('mt-dot w-1.5 h-1.5 rounded-full', meta.dot, meta.pulse && 'animate-pulse')} />
      {meta.label}
    </span>
  );
}

export function RowStatusBadge({ status, className }) {
  const cls = ROW_STATUS[status] || ROW_STATUS.Ready;
  return <span className={cn('badge border', cls, className)}>{status}</span>;
}

export function SideBadge({ side, className }) {
  const isBuy = String(side).toUpperCase() === 'BUY';
  return (
    <span
      className={cn(
        'badge border',
        isBuy ? 'bg-bull/10 border-bull/30 text-bull' : 'bg-bear/10 border-bear/30 text-bear',
        className,
      )}
    >
      {fmtValue(side)}
    </span>
  );
}

// Compact key:value chip used in the strategy card header summary line.
export function MetaChip({ label, value, className }) {
  return (
    <span className={cn('inline-flex items-center gap-1 text-2xs font-mono text-txt-muted', className)}>
      <span className="mt-meta text-txt-label">{label}:</span>
      <span className="text-txt-secondary">{value}</span>
    </span>
  );
}
